import { IStandardHeader } from './set/standard_header'
import { IStandardTrailer } from './set/standard_trailer'

/*
************************************************************
* The sequence reset message is used by the sending        *
* application to reset the incoming sequence number on the *
* opposing side.                                           *
************************************************************
*/
export interface ISequenceReset {
  StandardHeader: IStandardHeader// [1] BeginString.8, BodyLength.9 .. OnBehalfOfSendingTime.370
  GapFillFlag?: boolean// [2] 123 (Boolean)
  NewSeqNo: number// [3] 36 (Int)
  StandardTrailer: IStandardTrailer// [4] SignatureLength.93, Signature.89, CheckSum.10
}
